export default __webpack_public_path__ + "static/media/smart-contracts-home-animation.80b43d28.png";